import { FormControl, FormControlLabel, FormHelperText, FormLabel, makeStyles, Radio } from "@material-ui/core";
import { Field, useFormikContext } from "formik";
import { RadioGroup } from "formik-material-ui";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "block",
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  formLabel: {
    color: theme.palette.text.primary,
  },
}));

export default function FormikRadioField(props) {
  const classes = useStyles();
  const formik = useFormikContext();

  return (
    <FormControl
      className={classes.root}
      component="fieldset"
      {...props}
      error={Boolean(formik.touched[props.name] && formik.errors[props.name])}
      onChange={(e) => {
        const selectedVal = e.target.value;
        if (selectedVal === "true") {
          formik.setFieldValue(props.name, true);
        } else if (selectedVal === "false") {
          formik.setFieldValue(props.name, false);
        } else {
          formik.setFieldValue(props.name, selectedVal);
        }
      }}
    >
      <FormLabel component="legend" className={classes.formLabel} aria-label={props.label}>
        {props.label}
      </FormLabel>
      <Field component={RadioGroup} name={props.name}>
        {props.options.map((option) => (
          <FormControlLabel
            id={props.name + "-" + option.value + "-label"}
            value={option.value}
            control={<Radio id={props.name + "-" + option.value} size="small" />}
            label={option.label}
            aria-label={option.label}
            key={option.label}
          />
        ))}
      </Field>
      {formik.touched[props.name] && formik.errors[props.name] && (
        <FormHelperText data-cy={props.name + "-error-text"} id={props.name + "-error-text"}>
          {formik.errors[props.name]}
        </FormHelperText>
      )}
    </FormControl>
  );
}
